const geopopup_open = localStorage.getItem("geopopup");
const geo_popup = document.getElementById("geoip-popup");

$.get("https://ipinfo.io", function(response) {
  let country_code = response.country;

  if(country_code == 'AU'){
    console.log('in au')
  }else{
    if(geopopup_open != "true"){
      localStorage.setItem("geopopup", true);
      geo_popup.classList.add("now-visible");
    }
  }
}, "jsonp");

var geopopupClose = document.getElementById("geopopupClose");
geopopupClose.addEventListener("click", function(e) {
  geo_popup.classList.remove("now-visible");
})